export default __webpack_public_path__ + "static/media/Profi-School-brand.677e35b4.svg";